import EmailInput from 'components/FormFields/EmailInput/EmailInput'
import MoneyInput from 'components/FormFields/MoneyInput/MoneyInput'
import PhoneNumberInput from 'components/FormFields/PhoneNumberInput/PhoneNumberInput'
import OtpPhoneNumberInput from 'components/FormFields/PhoneNumberInput/AuthenticationInput'
import FileInput from 'components/FormFields/FileInput/FileInput'
import WebsiteInput from 'components/FormFields/WebsiteInput/WebsiteInput'
import RadioInput from 'components/FormFields/RadioInput/RadioInput'
import LongTextInput from 'components/FormFields/LongTextInput/LongTextInput'
import NumberInput from 'components/FormFields/NumberInput/NumberInput'
import SelectDropdownInput from 'components/FormFields/SelectDropdown/SelectDropdownInput'
import ToggleInput from 'components/FormFields/ToggleInput/ToggleInput'
import DateInput from 'components/FormFields/DateInput/DateInput'
import CheckboxInput from 'components/FormFields/CheckboxInput/CheckboxInput'
import MatrixInput from 'components/FormFields/MatrixInput/MatrixInput'
import TimeInput from 'components/FormFields/TimeInput/TimeInput'
import Rating from 'components/FormFields/Rating'
import MetaInput from 'components/FormFields/MetaInput/MetaInput'
import ShortText from 'components/FormFields/ShortText/ShortText'
import Signature from 'components/FormFields/Signature'
import Product from 'components/FormFields/Product/ProductInput'
import UnsupportedFields from 'components/FormFields/UnsupportedFields'
import HiddenInput from 'components/FormFields/Hidden/hidden'
import SearchableField from 'components/FormFields/SearchableInput'
import AdvanceMatrix from 'components/FormFields/MatrixInput/AdvanceMatrix'
import LookupInput from 'components/FormFields/LookupInput'
import EmailVerification from '../components/FormFields/EmailInput/EmailVerificationInput'
import OEmbed from 'components/FormFields/OEmbed'
import Variable from 'components/FormFields/Variable'
import SuccessPage from 'components/FormFields/SuccessPage'
import UserFieldInput from 'components/FormFields/UserField'

const fieldNameComponentMap = {
  dropdown: SelectDropdownInput,
  email: EmailInput,
  money: MoneyInput,
  // checkbox is a single input that must have a value yes or no, can not be null
  checkbox: ToggleInput,
  short_text: ShortText,
  phone: PhoneNumberInput,
  date: DateInput,
  multiple_select: CheckboxInput,
  file: FileInput,
  website: WebsiteInput,
  choice: RadioInput,
  long_text: LongTextInput,
  matrix: MatrixInput,
  number: NumberInput,
  time: TimeInput,
  // this input can be yes, no and null so a radio group is used to implement it
  yes_no: RadioInput,
  rating: Rating,
  meta: MetaInput,
  phone_verification: OtpPhoneNumberInput,
  email_verification: EmailVerification,
  signature: Signature,
  product: Product,
  hidden: HiddenInput,
  city: SearchableField,
  table: AdvanceMatrix,
  lookup: LookupInput,
  regex: ShortText,
  oembed: OEmbed,
  variable: Variable,
  user: UserFieldInput,
  success_page: SuccessPage,
}

const fieldTypeToFieldComponent = (fieldName) => {
  if (fieldNameComponentMap[fieldName]) {
    return fieldNameComponentMap[fieldName]
  }

  return UnsupportedFields // instead of throwing error and causing crashing the form editor, return empty span
}

export default fieldTypeToFieldComponent
